/**
 * Hook utilitaire pour détecter le thème corporate actif
 * Utilisé pour personnaliser logos, labels et couleurs par organisation
 */
import { useSyncExternalStore } from 'react';

const getSnapshot = () => document.documentElement.getAttribute('data-theme') || '';

const subscribe = (callback: () => void) => {
  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.attributeName === 'data-theme') {
        callback();
        break;
      }
    }
  });
  observer.observe(document.documentElement, { attributes: true, attributeFilter: ['data-theme'] });
  return () => observer.disconnect();
};

export const useActiveDataTheme = () => {
  const activeDataTheme = useSyncExternalStore(subscribe, getSnapshot, () => '');

  return {
    activeDataTheme,
    isCapgemini: activeDataTheme === 'capgemini',
    isLvmh: ['champagne-gold', 'royal-purple', 'midnight-platinum'].includes(activeDataTheme),
    isPyrescom: activeDataTheme === 'pyrescom',
    isCatalane: activeDataTheme === 'mutuelle-catalane',
    isViasante: activeDataTheme === 'viasante',
    isBps: activeDataTheme === 'bps',
    isBpce: activeDataTheme === 'bpce',
    isLvmhClientServices: activeDataTheme === 'lvmh-client-services',
    isAdocc: activeDataTheme === 'adocc',
  };
};
